module.exports = __webpack_public_path__ + "img/prop-trading-step-banner-mobile.461eda37.png";